// src/components/ActiveListGuard/ActiveListGuard.tsx
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import FixWidthContent from '../FixWidthContent';
import useGoToRoute from '../../hooks/useGoToRoute';
import { Path } from '../../constants/Path';
import { Roles } from '../../constants/Roles';
import { getActiveList, getUserData } from '../../views/auth/slice/selectors';
import classes from './ActiveListGuard.module.less';

// Wspólne dla wszystkich gier: bez aktywnej listy (wejście z zakładki albo wpisanego adresu) zamiast gry
// ekran z powrotem do list. Gry od razu czytają słowa listy i część z nich bez niej się wywraca.
const ActiveListGuard: FC = ({ children }) => {
  const { t } = useTranslation();
  const activeList = useSelector(getActiveList);
  const user = useSelector(getUserData);
  // Listę do gier nauczyciel wybiera na swoich listach słówek, uczeń — na ekranie swoich list
  const goToLists = useGoToRoute(user?.role === Roles.TEACHER ? Path.WORDS_LIST : Path.MY_LISTS);

  if (!activeList?.words?.length) {
    return (
      <FixWidthContent>
        <Result
          className={classes.result}
          status="warning"
          title={t('games:states.noActiveList')}
          subTitle={t('games:states.chooseList')}
          extra={(
            <Button type="primary" onClick={goToLists}>
              {t('games:states.backToLists')}
            </Button>
          )}
        />
      </FixWidthContent>
    );
  }

  return <>{children}</>;
};

export default ActiveListGuard;
